import { useEffect, useState } from "react";
import { useReport } from "../../../../tools/api";
import { Dropdown, Table } from "antd";
import { NotFound } from "../../../../sources/svg/svg";
import { MoreOutlined } from "@ant-design/icons";
import { SwitchStateMsisdn } from "../../../../tools/tools";
import { Link, useNavigate } from "react-router-dom";
import { _adr } from "../../../../address";
import { Roles } from "../../../../tools/services";

const Result = ({ user = {}, type = -1, search = "" }) => {
	const { querySPPurchaseDealerByCertNo, querySPPurchaseDealerByMSISDN } = useReport();
	const nav = useNavigate();
	const [resultSearch, setResultSearch] = useState({
		currentPage: 0, //state current page show Records
		totalRecord: 0, // state totalRecord
		result: [],
		isLoading: false,
	});

	const items = [
		{
			key: "purchaseDC",
			label: "خرید شارژ",
		},
		{
			key: "purchaseEP",
			label: "خرید بسته",
		},
		{
			key: "payBill",
			label: "پرداخت قبض دایمی",
		},
		{
			key: "updateNetwork",
			label: "تغییر شبکه موبایل",
		},
		{
			key: "changeSimCard",
			label: "تعویض سیم کارت",
		},
		user.roles.includes(Roles.Dealer_ChangeStatus_B2B) && {
			key: "ChangeSimStatus",
			label: "تغییر وضعیت سیم‌کارت",
		},
		user.roles.includes(Roles.Dealer_ChangeOwner_B2BCustomer_Iranian) && {
			key: "changeOwnerShip",
			label: "تغییر مالکیت",
		},
	];
	const onMenuClick = (path, item) => {
		switch (path) {
			case "updateNetwork":
				nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.UpdateNetwork, { state: item });
				return;
			case "changeSimCard":
				nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.ValidKit, { state: item });
				return;
			case "changeOwnerShip":
				nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Profile, { state: item });
				return;
			case "purchaseDC":
				nav(_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Charge, { state: item });
				return;
			case "purchaseEP":
				nav(_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.Valid, { state: item });
				return;
			case "payBill":
				nav(_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Bill, { state: item });
				return;
			case "ChangeSimStatus":
				nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.ChangeStatusSim, { state: item });
				return;
			default:
				return "";
		}
	};
	useEffect(() => {
		const callService = async () => {
			setResultSearch((result) => ({ ...result, isLoading: true }));
			let payload = {
				sort: "",
				filter: search,
				entriesperpage: 10,
				page: resultSearch?.currentPage === 0 ? 0 : resultSearch?.currentPage - 1,
				totalrowcount: 0,
			};
			let response = {};
			if (type == "0") {
				response = await querySPPurchaseDealerByCertNo(payload);
			} else {
				response = await querySPPurchaseDealerByMSISDN(payload);
			}
			if (response) {
				const resultMap = response?.Result?.map((item, key) => ({
					key: key,
					inT_MSISDN: (
						<Link to={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Action} state={item} dir="ltr">
							0{item.inT_MSISDN}
						</Link>
					),
					inT_MSISDNSimcardType: item.inT_MSISDNSimcardType ? "دائمی" : "اعتباری",
					stR_CertNo: item.stR_CertNo,
					stR_FName: item.stR_FName,
					fullname: item.firstName + " " + item.lastName,
					status: <span>{SwitchStateMsisdn(item.inT_MSISDNStatusType)}</span>,
					action: (
						<>
							<Dropdown.Button
								icon={<MoreOutlined />}
								menu={{
									items: items
										.filter((i) => {
											return !(
												(i.key === "purchaseDC" && item.inT_MSISDNSimcardType != 0) ||
												(i.key === "payBill" && item.inT_MSISDNSimcardType != 1)
											);
										})
										.map((i) => i),
									purchase: item,
									onClick: (e) => onMenuClick(e.key, item),
								}}
							/>
						</>
					),
				}));
				setResultSearch((result) => ({ ...result, result: resultMap, totalRecord: response?.searchconfigmodel?.totalrowcount }));
			}
			setResultSearch((result) => ({ ...result, isLoading: false }));
		};
		if (type !== -1) callService();
	}, [type, search, resultSearch.currentPage]);

	return (
		<>
			<style>
				{`
					.ant-space-compact-block .ant-btn-compact-first-item {
						display: none; /* مخفی کردن دکمه اصلی */
					  }
					  
					  .ant-space-compact-block .ant-dropdown-trigger {
						border-radius:6px !important;
						  display:flex;
						  justify-content:center;
						  align-items:center;
						  height:auto;
						  
						  span{
							  display:block;
							  margin:auto;
						  }
					  }
				`}
			</style>
			<div className="holder-table">
				<Table
					className="tbl-normal"
					loading={resultSearch.isLoading}
					columns={[
						{ key: "inT_MSISDN", dataIndex: "inT_MSISDN", title: "شماره" },
						{ key: "inT_MSISDNSimcardType", dataIndex: "inT_MSISDNSimcardType", title: "نوع سیم‌کارت" },
						{ key: "stR_CertNo", dataIndex: "stR_CertNo", title: "شناسه ملی" },
						{ key: "stR_FName", dataIndex: "stR_FName", title: "نام شرکت" },
						{ key: "fullname", dataIndex: "fullname", title: "نام نماینده" },
						{ key: "status", dataIndex: "status", title: "وضعیت" },
						{ key: "action", dataIndex: "action", title: "" },
					]}
					locale={{
						emptyText: (
							<>
								<NotFound text={"رکوردی یافت نشد."} />
							</>
						),
					}}
					pagination={{
						className: "page-pagination",
						// position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
						onChange: (page) => {
							setResultSearch((result) => ({ ...result, currentPage: page }));
						},
						pageSize: 10,
						align: "start",
						current: resultSearch.currentPage === 0 ? 1 : resultSearch.currentPage,
						total: resultSearch.totalRecord,
						showSizeChanger: false,
					}}
					scroll={{ y: "100%" }}
					dataSource={resultSearch.result}
				/>
			</div>
		</>
	);
};

export default Result;
